export default function DisclaimerBar({ variant = "bottom" }) {
    if (variant === "inline") {
        return (
            <p className="text-[11px] text-soft_muted leading-relaxed" data-testid="disclaimer-inline">
                La información mostrada tiene carácter meramente informativo y educativo. QCapital no presta asesoramiento financiero, recomendaciones personalizadas, gestión de carteras, intermediación, custodia ni ejecución de órdenes. Las decisiones de inversión son responsabilidad exclusiva del usuario.
            </p>
        );
    }
    return (
        <div
            className="border-t border-soft_border bg-stone/60 backdrop-blur-sm py-2.5 px-6 text-center"
            data-testid="disclaimer-bar"
        >
            <p className="text-[10px] uppercase tracking-[0.18em] text-soft_muted">
                Análisis, no asesoramiento financiero · Datos de carácter informativo
            </p>
        </div>
    );
}
